import DOMPurify from 'dompurify'

/**
 * Sanitize markup or text when used inside dangerouslysetInnerHTML
 *
 * @param {string} content Plain or html string.
 *
 * @return {string} Sanitized string
 */

const isBrowser = typeof window !== 'undefined'

export const sanitize = (content: any) => {
  return isBrowser ? DOMPurify.sanitize(content) : content
}
